/*
 *  Document   : client-company-users.js
 *  Author     : Exapoint
 *
 */

// Import required modules

export default class ClientCompanyUsers {

    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ClientCompanyUsers"] = this;
        this.init();
    }

    init() {
        this.test()
        $('#company-users-table').DataTable({
            ajax: jsVars.datatablesAjax,
            order: [[1, "desc"]],
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
                {data: "user.id"},
                {
                    data: 'user.full_name',
                    render: function (data, type, row) {
                        let html = '';

                        if(( row.is_colleague !== undefined )){
                            let colleagueBadge = row.is_colleague !== 0 ? this.addColleagueBadgeTemplate() : '';
                            html = data ? `<span class="company-user-link" onclick="ClientCompanyUsers.showUser(${row.id}, '${data}')">${data}</span>` + colleagueBadge : '';

                            if (row.made_colleague) {
                                html += `${this.addMadeYouColleagueTemplate()}`;
                            }
                        }else{
                           html += `<span class="placeholder text-dark font-w500">${data}</span>`;
                        }

                        return html;
                    }.bind(this)
                },
                {
                    data: "user.email",
                    render: function (data, type, row) {
                        return `<a href="mailto:${data ? data : ''}" class="">${data ? data : ''}</a>`
                    }
                },
                {
                    data: "user.phone_number",
                    render: function (data, type, row) {
                        return `<a href="tel:${data ? data : ''}" class="text-color-table">${data ? data : ''}</a>`
                    }
                },
                {
                    data: "user.mobile_number",
                    render: function (data, type, row) {
                        return `<a href="tel:${data ? data : ''}" class="text-color-table">${data ? data : ''}</a>`
                    }
                },
            ],
            drawCallback: function () {
                if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden')
            },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true,
            bPaginate: false,
        });
    }

    showUser(id, userName) {

        this.$userTabLink = this.$userTabLink ?? $('.company-user-info-nav');
        this.$userTab = this.$userTab ?? this.$userTabLink.find('a');
        this.$userTabContent = this.$userTabContent ?? $('#company-user-info');

        this.$userTabContent.html('');
        $.ajax({
            type: 'GET',
            url: jsVars.userInfoUrl.replace(':user-id', id),
        }).then((response) => {

            if (response !== "") {
                this.$userTabContent.html(response);
                this.$userTabLink.show();
                this.$userTab.tab('show');
                this.$userTab.html(userName.trim());


                this.$userTab.on('hidden.bs.tab', function () {
                    this.$userTabContent.html('');
                    this.$userTabLink.hide();
                    this.$userTab.html('');
                    this.$userTab.unbind('hidden.bs.tab');
                }.bind(this));
            }
        }).fail(() => {
        });
    }

    addColleagueBadgeTemplate() {
        return `
        <div class="removed-badge">
            <span class="badge badge-pill badge-info">${jsVars.colleagueText}</span>
        </div>
        `;
    }

    addMadeYouColleagueTemplate() {
        return `
        <div class="removed-badge">
            <span class="badge badge-pill badge-info">${jsVars.madeYouColleagueText}</span>
        </div>
        `;
    }
    test() {
        console.log('lol');
    }
}
